import request from '@/utils/httpClient'
import { PaginationRequest } from '@/model/PaginationRequest'

export interface NotificationQueryRequest extends PaginationRequest {
  isRead?: boolean;
}

/**
 * 获取当前用户未读消息数
 */
export function getUnreadCount() {
  return request({
    url: 'notification/unread-count',
    method: 'get'
  })
}

/**
 * 分页查询通知列表
 */
export function getNotificationPage(params: NotificationQueryRequest) {
  return request({
    url: 'notification/page',
    method: 'get',
    params
  })
}

/**
 * 标记消息为已读
 */
export function markAsRead(id: number) {
  return request({
    url: `notification/${id}/read`,
    method: 'put'
  })
}

/**
 * 删除消息
 */
export function deleteNotification(id: number) {
  return request({
    url: `notification/${id}`,
    method: 'delete'
  })
}
